module.exports = __webpack_public_path__ + "assets/img/home-service-price.d5615c0e.png";